import React from 'react';
import Button from '../../shared/Button';
import Input from '../../shared/Input';
import ModalShell from '../../shared/ModalShell';

const AddPlatformModal = ({
  isOpen,
  newPlatformName,
  setNewPlatformName,
  onAdd,
  onCancel
}) => {
  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onCancel}
      labelledBy="add-platform-title"
      panelClassName="max-w-md"
    >
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="p-4 sm:p-6">
          <h3 id="add-platform-title" className="text-base sm:text-lg font-semibold text-gray-900 dark:text-gray-50 mb-3 sm:mb-4">
            Add Social Media Platform
          </h3>
          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-4">
            Enter the name of the social media platform you want to add.
          </p>
          <div className="mb-4 sm:mb-6">
            <Input
              label="Platform Name"
              value={newPlatformName}
              onChange={(e) => setNewPlatformName(e.target.value)}
              placeholder="e.g., facebook, instagram, twitter"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onAdd();
                } else if (e.key === 'Escape') {
                  onCancel();
                }
              }}
            />
          </div>
          <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-3">
            <Button
              onClick={onCancel}
              variant="outline"
              className="w-full sm:w-auto !rounded-xl"
            >
              Cancel
            </Button>
            <Button
              onClick={onAdd}
              disabled={!newPlatformName.trim()}
              className="w-full sm:w-auto !rounded-xl"
            >
              Add Platform
            </Button>
          </div>
        </div>
      </div>
    </ModalShell>
  );
};

export default AddPlatformModal;
